// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v3.12.4
// source: brain_system_msgs.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Header } from "./std_msgs";

export const protobufPackage = "brain_system_msgs.proto";

export interface DiagnosticStatus {
  header: Header | undefined;
  key: string;
  value: string;
  description: string;
  type: DiagnosticStatus_Type;
  level: DiagnosticStatus_Level;
}

export enum DiagnosticStatus_Type {
  UNKNOWN = 0,
  OUT_OF_RANGE = 1,
  UNEXPECTED_RATE = 2,
  INVALID_VALUE = 3,
  INTERNAL = 4,
  FUNCTIONAL = 100,
  HARDWARE = 200,
  UNRECOGNIZED = -1,
}

export enum DiagnosticStatus_Level {
  /** OK - OK is a reserved keyword in some languages */
  OK = 0,
  WARNING = 2,
  ERROR = 3,
  FATAL = 4,
  UNRECOGNIZED = -1,
}

export interface NodeStatus {
  header: Header | undefined;
  name: string;
  activated: boolean;
  status: DiagnosticStatus[];
}

export interface AggregatedNodeStatus {
  header: Header | undefined;
  nodeStatus: NodeStatus[];
}

export interface HardwareStatus {
  header: Header | undefined;
  name: string;
  status: DiagnosticStatus[];
}

export interface LoggerInfo {
  header: Header | undefined;
  loggingStatus: LoggerInfo_LoggingStatus;
  regularLogging: boolean;
  eventLogging: boolean;
  manualLogging: boolean;
}

export enum LoggerInfo_LoggingStatus {
  LOGGING_NA = 0,
  LOGGING_PAUSE = 1,
  LOGGING_RUNNING = 2,
  LOGGING_ERROR = 3,
  UNRECOGNIZED = -1,
}

export interface RemoteControlStatus {
  header: Header | undefined;
  remoteType: RemoteControlStatus_RemoteType;
  connectionStatus: RemoteControlStatus_ConnectionStatus;
  connectionQuality: RemoteControlStatus_ConnectionQuality;
  rttMs: number;
  activator: RemoteControlStatus_Activator;
  stationId: string;
  hardwareFault: boolean;
  softwareFault: boolean;
  errorCode: number;
}

export enum RemoteControlStatus_RemoteType {
  CTRL_NONE = 0,
  CTRL_DIRECT = 1,
  CTRL_PROFILE = 2,
  CTRL_WAYPOINT = 3,
  CTRL_SEMANTIC = 4,
  CTRL_EMERGENCY = 5,
  UNRECOGNIZED = -1,
}

export enum RemoteControlStatus_ConnectionStatus {
  STATUS_NA = 0,
  STATUS_DISCONNECTED = 1,
  STATUS_CONNECTED_REMOTEREQ = 2,
  STATUS_CONNECTED_VEHICLEREQ = 3,
  STATUS_WARNING = 4,
  STATUS_ERROR = 5,
  UNRECOGNIZED = -1,
}

export enum RemoteControlStatus_ConnectionQuality {
  QUALITY_UNKNOWN = 0,
  QUALITY_GOOD = 1,
  QUALITY_UNSTABLE = 2,
  QUALITY_BAD = 3,
  QUALITY_LOST = 4,
  UNRECOGNIZED = -1,
}

export enum RemoteControlStatus_Activator {
  ACTIVATOR_UNKNOWN = 0,
  ACTIVATOR_BRAIN = 1,
  ACTIVATOR_REMOTE = 2,
  ACTIVATOR_EXTERNAL_SERVICE = 3,
  UNRECOGNIZED = -1,
}

export interface SystemInfo {
  header: Header | undefined;
  timeSyncState: boolean;
  vCanStatus: boolean;
  avsStatus: boolean;
  networkAvailable: number;
  deviceAliveCode: number;
  connectionNodes: number;
  voltageLevel: number;
}

export interface SystemStatus {
  header: Header | undefined;
  mode: SystemStatus_Mode;
  level: SystemStatus_Level;
  status: NodeStatus[];
  errorCode: number;
}

export enum SystemStatus_Mode {
  SIMULATION = 0,
  INDIVIDUAL = 1,
  INTEGRATION = 2,
  DEMONSTRATION = 3,
  UNRECOGNIZED = -1,
}

export enum SystemStatus_Level {
  /** LEVEL_OK - Renamed */
  LEVEL_OK = 0,
  LEVEL_WARNING = 2,
  LEVEL_ERROR = 3,
  LEVEL_FATAL = 4,
  UNRECOGNIZED = -1,
}

export interface AckInfo {
  header: Header | undefined;
  ack: Header | undefined;
}

function createBaseDiagnosticStatus(): DiagnosticStatus {
  return { header: undefined, key: "", value: "", description: "", type: 0, level: 0 };
}

export const DiagnosticStatus: MessageFns<DiagnosticStatus> = {
  encode(message: DiagnosticStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.key !== "") {
      writer.uint32(18).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(26).string(message.value);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.type !== 0) {
      writer.uint32(40).int32(message.type);
    }
    if (message.level !== 0) {
      writer.uint32(48).int32(message.level);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DiagnosticStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiagnosticStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.value = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.level = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<DiagnosticStatus>, I>>(base?: I): DiagnosticStatus {
    return DiagnosticStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DiagnosticStatus>, I>>(object: I): DiagnosticStatus {
    const message = createBaseDiagnosticStatus();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    message.description = object.description ?? "";
    message.type = object.type ?? 0;
    message.level = object.level ?? 0;
    return message;
  },
};

function createBaseNodeStatus(): NodeStatus {
  return { header: undefined, name: "", activated: false, status: [] };
}

export const NodeStatus: MessageFns<NodeStatus> = {
  encode(message: NodeStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.activated !== false) {
      writer.uint32(24).bool(message.activated);
    }
    for (const v of message.status) {
      DiagnosticStatus.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodeStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNodeStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.activated = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.status.push(DiagnosticStatus.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<NodeStatus>, I>>(base?: I): NodeStatus {
    return NodeStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodeStatus>, I>>(object: I): NodeStatus {
    const message = createBaseNodeStatus();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.name = object.name ?? "";
    message.activated = object.activated ?? false;
    message.status = object.status?.map((e) => DiagnosticStatus.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAggregatedNodeStatus(): AggregatedNodeStatus {
  return { header: undefined, nodeStatus: [] };
}

export const AggregatedNodeStatus: MessageFns<AggregatedNodeStatus> = {
  encode(message: AggregatedNodeStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.nodeStatus) {
      NodeStatus.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AggregatedNodeStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAggregatedNodeStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeStatus.push(NodeStatus.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<AggregatedNodeStatus>, I>>(base?: I): AggregatedNodeStatus {
    return AggregatedNodeStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AggregatedNodeStatus>, I>>(object: I): AggregatedNodeStatus {
    const message = createBaseAggregatedNodeStatus();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.nodeStatus = object.nodeStatus?.map((e) => NodeStatus.fromPartial(e)) || [];
    return message;
  },
};

function createBaseHardwareStatus(): HardwareStatus {
  return { header: undefined, name: "", status: [] };
}

export const HardwareStatus: MessageFns<HardwareStatus> = {
  encode(message: HardwareStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    for (const v of message.status) {
      DiagnosticStatus.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HardwareStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHardwareStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.status.push(DiagnosticStatus.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<HardwareStatus>, I>>(base?: I): HardwareStatus {
    return HardwareStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HardwareStatus>, I>>(object: I): HardwareStatus {
    const message = createBaseHardwareStatus();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.name = object.name ?? "";
    message.status = object.status?.map((e) => DiagnosticStatus.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLoggerInfo(): LoggerInfo {
  return { header: undefined, loggingStatus: 0, regularLogging: false, eventLogging: false, manualLogging: false };
}

export const LoggerInfo: MessageFns<LoggerInfo> = {
  encode(message: LoggerInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.loggingStatus !== 0) {
      writer.uint32(16).int32(message.loggingStatus);
    }
    if (message.regularLogging !== false) {
      writer.uint32(24).bool(message.regularLogging);
    }
    if (message.eventLogging !== false) {
      writer.uint32(32).bool(message.eventLogging);
    }
    if (message.manualLogging !== false) {
      writer.uint32(40).bool(message.manualLogging);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoggerInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoggerInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.loggingStatus = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.regularLogging = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.eventLogging = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.manualLogging = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<LoggerInfo>, I>>(base?: I): LoggerInfo {
    return LoggerInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoggerInfo>, I>>(object: I): LoggerInfo {
    const message = createBaseLoggerInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.loggingStatus = object.loggingStatus ?? 0;
    message.regularLogging = object.regularLogging ?? false;
    message.eventLogging = object.eventLogging ?? false;
    message.manualLogging = object.manualLogging ?? false;
    return message;
  },
};

function createBaseRemoteControlStatus(): RemoteControlStatus {
  return {
    header: undefined,
    remoteType: 0,
    connectionStatus: 0,
    connectionQuality: 0,
    rttMs: 0,
    activator: 0,
    stationId: "",
    hardwareFault: false,
    softwareFault: false,
    errorCode: 0,
  };
}

export const RemoteControlStatus: MessageFns<RemoteControlStatus> = {
  encode(message: RemoteControlStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.remoteType !== 0) {
      writer.uint32(16).int32(message.remoteType);
    }
    if (message.connectionStatus !== 0) {
      writer.uint32(24).int32(message.connectionStatus);
    }
    if (message.connectionQuality !== 0) {
      writer.uint32(32).int32(message.connectionQuality);
    }
    if (message.rttMs !== 0) {
      writer.uint32(45).float(message.rttMs);
    }
    if (message.activator !== 0) {
      writer.uint32(48).int32(message.activator);
    }
    if (message.stationId !== "") {
      writer.uint32(58).string(message.stationId);
    }
    if (message.hardwareFault !== false) {
      writer.uint32(64).bool(message.hardwareFault);
    }
    if (message.softwareFault !== false) {
      writer.uint32(72).bool(message.softwareFault);
    }
    if (message.errorCode !== 0) {
      writer.uint32(80).uint32(message.errorCode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteControlStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteControlStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.remoteType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.connectionStatus = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.connectionQuality = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.rttMs = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.activator = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.stationId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.hardwareFault = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.softwareFault = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.errorCode = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteControlStatus>, I>>(base?: I): RemoteControlStatus {
    return RemoteControlStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteControlStatus>, I>>(object: I): RemoteControlStatus {
    const message = createBaseRemoteControlStatus();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.remoteType = object.remoteType ?? 0;
    message.connectionStatus = object.connectionStatus ?? 0;
    message.connectionQuality = object.connectionQuality ?? 0;
    message.rttMs = object.rttMs ?? 0;
    message.activator = object.activator ?? 0;
    message.stationId = object.stationId ?? "";
    message.hardwareFault = object.hardwareFault ?? false;
    message.softwareFault = object.softwareFault ?? false;
    message.errorCode = object.errorCode ?? 0;
    return message;
  },
};

function createBaseSystemInfo(): SystemInfo {
  return {
    header: undefined,
    timeSyncState: false,
    vCanStatus: false,
    avsStatus: false,
    networkAvailable: 0,
    deviceAliveCode: 0,
    connectionNodes: 0,
    voltageLevel: 0,
  };
}

export const SystemInfo: MessageFns<SystemInfo> = {
  encode(message: SystemInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.timeSyncState !== false) {
      writer.uint32(16).bool(message.timeSyncState);
    }
    if (message.vCanStatus !== false) {
      writer.uint32(24).bool(message.vCanStatus);
    }
    if (message.avsStatus !== false) {
      writer.uint32(32).bool(message.avsStatus);
    }
    if (message.networkAvailable !== 0) {
      writer.uint32(40).uint32(message.networkAvailable);
    }
    if (message.deviceAliveCode !== 0) {
      writer.uint32(48).uint32(message.deviceAliveCode);
    }
    if (message.connectionNodes !== 0) {
      writer.uint32(56).uint32(message.connectionNodes);
    }
    if (message.voltageLevel !== 0) {
      writer.uint32(69).float(message.voltageLevel);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SystemInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSystemInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.timeSyncState = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.vCanStatus = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.avsStatus = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.networkAvailable = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.deviceAliveCode = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.connectionNodes = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.voltageLevel = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SystemInfo>, I>>(base?: I): SystemInfo {
    return SystemInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SystemInfo>, I>>(object: I): SystemInfo {
    const message = createBaseSystemInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.timeSyncState = object.timeSyncState ?? false;
    message.vCanStatus = object.vCanStatus ?? false;
    message.avsStatus = object.avsStatus ?? false;
    message.networkAvailable = object.networkAvailable ?? 0;
    message.deviceAliveCode = object.deviceAliveCode ?? 0;
    message.connectionNodes = object.connectionNodes ?? 0;
    message.voltageLevel = object.voltageLevel ?? 0;
    return message;
  },
};

function createBaseSystemStatus(): SystemStatus {
  return { header: undefined, mode: 0, level: 0, status: [], errorCode: 0 };
}

export const SystemStatus: MessageFns<SystemStatus> = {
  encode(message: SystemStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.mode !== 0) {
      writer.uint32(16).int32(message.mode);
    }
    if (message.level !== 0) {
      writer.uint32(24).int32(message.level);
    }
    for (const v of message.status) {
      NodeStatus.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.errorCode !== 0) {
      writer.uint32(40).uint32(message.errorCode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SystemStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSystemStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.level = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.status.push(NodeStatus.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.errorCode = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SystemStatus>, I>>(base?: I): SystemStatus {
    return SystemStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SystemStatus>, I>>(object: I): SystemStatus {
    const message = createBaseSystemStatus();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.mode = object.mode ?? 0;
    message.level = object.level ?? 0;
    message.status = object.status?.map((e) => NodeStatus.fromPartial(e)) || [];
    message.errorCode = object.errorCode ?? 0;
    return message;
  },
};

function createBaseAckInfo(): AckInfo {
  return { header: undefined, ack: undefined };
}

export const AckInfo: MessageFns<AckInfo> = {
  encode(message: AckInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.ack !== undefined) {
      Header.encode(message.ack, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AckInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAckInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ack = Header.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<AckInfo>, I>>(base?: I): AckInfo {
    return AckInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AckInfo>, I>>(object: I): AckInfo {
    const message = createBaseAckInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.ack = (object.ack !== undefined && object.ack !== null) ? Header.fromPartial(object.ack) : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
